module.exports = __webpack_public_path__ + "static/media/114-british-virgin-islands.36cd73e4.svg";